/**
 * Converia.Invoice.PaymentDefaultStrategie
 */
Converia.Core.module('Converia.Invoice.PaymentDefaultStrategie', function () {
    /**
     * PaymentDefaultStrategie
     * 
     * @param begui
     * @constructor
     */
    var PaymentDefaultStrategie = function (begui) {

    };

    /**
     * PaymentDefaultStrategie.prototype.handleBeforeSubmit
     * 
     * @returns {boolean}
     */
    PaymentDefaultStrategie.prototype.handleBeforeSubmit = function () {
        return true;
    };

    return PaymentDefaultStrategie;
});